import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter as Router, Route, Link} from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

import "./css/styles.css";
import 'react-big-calendar/lib/css/react-big-calendar.css';

import Header from "./main/header";
import PillarsSection from "./main/pillars";
import ValuesSection from "./main/values";
import PossibilitiesSection from "./main/possibilities";
import CalendarSection from "./main/calendar";
import CalloutSection from "./main/callout";
import ContactSection from "./main/contact";
import OpeningSection from "./main/opening";
import MapSection from "./main/map";
import FooterSection from "./main/footer";
import ScrollToTop from "./main/scrollToTop";

import SportSection from "./courseinfo/sport"
import TrainingSection from "./courseinfo/training"
import RelaxSection from "./courseinfo/relax"
import PersonalTrainingSection from "./courseinfo/personal"
import MassageSection from "./courseinfo/massage"
import HealthySection from "./courseinfo/healthy"

class App extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
        <Router>
          <div>
            <Navbar color="light" light expand="md" className="navBarBackground fixed-top">
              <NavbarBrand href="/#top">Medi Zentrum</NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
              <Nav navbar>
                <NavItem><NavLink href="/#pillars">Mantra</NavLink></NavItem>
                <NavItem><NavLink href="/#values">Werte</NavLink></NavItem>
                <NavItem><NavLink href="/#possibilities">Möglichkeiten</NavLink></NavItem>
                <NavItem><NavLink href="/#courses">Kurse</NavLink></NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>Kursinfos</DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem><NavLink href="/kursinfo#reha">Reha Sport</NavLink></DropdownItem>
                    <DropdownItem><NavLink href="/kursinfo#training">Funktionstraining</NavLink></DropdownItem>
                    <DropdownItem><NavLink href="/kursinfo#relax">Entspannungskurse</NavLink></DropdownItem>
                    <DropdownItem><NavLink href="/kursinfo#personal">Personaltraining</NavLink></DropdownItem>
                    <DropdownItem><NavLink href="/kursinfo#massage">Massagen</NavLink></DropdownItem>
                    <DropdownItem><NavLink href="/kursinfo#healthy">BioFeedback</NavLink></DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <NavItem><NavLink href="/#contact">Kontakt</NavLink></NavItem>
                <NavItem><NavLink href="/#opening">Öffnungszeiten</NavLink></NavItem>
                <NavItem><NavLink href="/#location">Anfahrt</NavLink></NavItem>
              </Nav>
              </Collapse>
            </Navbar>
            <Route exact path="/" component={Home}/>
            <Route exact path="/kursinfo" component={CourseInfo}/>
          </div>
        </Router>
    );
  }
}

const Home = () => (
    <div>
      <Header/>
      <PillarsSection/>
      <ValuesSection/>
      <PossibilitiesSection/>
      <CalendarSection/>
      <CalloutSection/>
      <ContactSection/>
      <OpeningSection/>
      <MapSection/>
      <FooterSection/>
      <ScrollToTop/>
    </div>
);

const CourseInfo = () => (
    <div>
      <SportSection/>
      <TrainingSection/>
      <RelaxSection/>
      <PersonalTrainingSection/>
      <MassageSection/>
      <HealthySection/>
      <FooterSection/>
    </div>
);


const rootElement = document.getElementById("root");
ReactDOM.render(<App/>, rootElement);



// WEBPACK FOOTER //
// ./src/index.js